// extracted by mini-css-extract-plugin
module.exports = {"backLink":"BackLink_backLink__3Tkt5","backLinkText":"BackLink_backLinkText__2cxpp"};